import type { AiToolCall } from '@wordpuppi/shared';

/**
 * AB#673: a build tool call carries the site's shareable preview link. Only
 * `wpp_build_site` gets the "Open preview" affordance — other tools may echo a
 * preview_url through the same plumbing without having just built anything.
 */
export function previewLinkFor(call: Pick<AiToolCall, 'name' | 'preview_url'>): string | null {
  return call.name === 'wpp_build_site' && call.preview_url ? call.preview_url : null;
}

export { barkLinksFor } from '@wordpuppi/shared';
